import { styled } from 'styled-components';

import { Body } from '#/components/Text/Body';
import type { CmsApiBlockquoteBlockData } from '#/modules/cms/api/types/blocks/CmsApiBlockquoteBlock';
import { colors, cssBreakpoints, gutterWidth, spacing } from '#/theme/theme';

import { CmsBlockquoteBlock_Box_1 } from './CmsBlockquoteBlock.styled';

type Props = {
  blockIndex: number;
  data: CmsApiBlockquoteBlockData;
  className?: string;
};

const CmsBlockquoteBlockInnerHolder = styled.div`
  position: relative;
  padding-inline: ${spacing[24]};
  padding-bottom: ${gutterWidth / 2}px;
  padding-top: ${gutterWidth}px;

  *:first-child {
    margin-top: 0;
  }

  *:last-child {
    margin-bottom: 0;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    padding-inline: 48px;
  }

  &[data-style='QUOTE']::before {
    content: '“';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -35%);
    color: ${colors.brandYellow};
    font-size: 100px;
    font-weight: 700;
    line-height: 1;
  }

  &[data-style='CALLOUT']::before {
    content: '';
    display: block;
    position: absolute;
    top: 36px;
    left: 48px;
    background-color: ${colors.brandYellow};
    height: 4px;
    width: 70px;

    @media all and (max-width: ${cssBreakpoints.smDown}) {
      left: 24px;
      height: 3px;
    }
  }
`;

export function CmsBlockquoteBlock({
  blockIndex,
  data: { quote, cite, style },
}: Props) {
  return (
    <div>
      <CmsBlockquoteBlock_Box_1>
        <CmsBlockquoteBlockInnerHolder
          data-style={style}
          style={{ textAlign: style === 'QUOTE' ? 'center' : 'left' }}
        >
          <Body
            analyticsData={{
              eventName: 'CMS Block',
              eventProperties: {
                block_position: blockIndex,
                block_type: 'Block Quote',
              },
            }}
            styleAs={quote.length > 225 ? 'body' : 'bodyLarge'}
            dangerouslySetInnerHTML={{
              __html: quote,
            }}
          />

          {cite && (
            <div style={{ marginTop: '18px' }}>
              <Body>{cite}</Body>
            </div>
          )}
        </CmsBlockquoteBlockInnerHolder>
      </CmsBlockquoteBlock_Box_1>
    </div>
  );
}
